module.exports = __webpack_public_path__ + "img/telehealth_phone-call.68a7142e.svg";